import { GridToolbarColumnsButton, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { GridPagination } from '@mui/x-data-grid';
import { GridToolbarDensitySelector } from '@mui/x-data-grid';
import { GridToolbarContainer } from '@mui/x-data-grid';
import { USER_ROLES } from 'constants';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useDataTableSlots = (hasExport = false, pagination = true, isLoading = false) => {
    const authData = useSelector((s) => s.auth.data);
    const data = useMemo(() => ({
        toolbar: () => (
            <GridToolbarContainer>
                <GridToolbarColumnsButton sx={{ color: "var(--bs-primary) !important" }} />
                <GridToolbarFilterButton sx={{ color: "var(--bs-primary) !important" }} />
                <GridToolbarDensitySelector sx={{ color: "var(--bs-primary) !important" }} />
                {(hasExport === true ||
                    USER_ROLES.data_migrator.includes(parseInt(authData.role_id)) ||
                    USER_ROLES.admin_users.includes(parseInt(authData.role_id))) && (
                    <GridToolbarExport sx={{ color: "var(--bs-primary) !important" }}
                    disabled={isLoading} />
                )}

                <GridToolbarQuickFilter sx={{ marginLeft: "auto" }} />
                {pagination === true && <GridPagination sx={{ marginLeft: 2 }} />}
            </GridToolbarContainer>
        ),
        moreActionsIcon: () => <i className="fas fa-ellipsis-h fa-1-5x text-primary" />,
    }), [hasExport, pagination, authData.role_id, isLoading]);
    return data;
}

export default useDataTableSlots;
